ace.define("ace/snippets/text",["require","exports","module"],function(e,t,n){"use strict";t.snippetText=undefined,t.scope="text"})


//////////////////
// WEBPACK FOOTER
// ./~/brace/snippets/text.js
// module id = 279
// module chunks = 1